/* eslint-disable no-useless-escape */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ResultList as HeadlessResultList, ResultsPerPage as HeadlessResultsPerPage } from '@coveo/headless';
import {FrequentlyBoughtTogetherList} from "@coveo/headless/product-recommendation";
import React, { FunctionComponent, useEffect, useState, Fragment } from 'react';
import {filetype, highlightSearchTerm, viewMode} from '../../../utils/utils';
import AffiliateNoResultFilter from "../../AffiliateStores/AffiliateSearchListing/AffiliateNoResultFilter";
import InetPdfPreview from './InetPdfPreview';
import InetDownload from './InetDownload';
import { InteractiveResult } from './InteractiveResult';
import NoResultsByFilters from "./NoResultsByFilters";
import Product from './Product';
import WasThisHelpful from './WasThisHelpful';
import './scss/ListingItem.scss';
import './scss/LoadMore.scss';
import $ from 'jquery';

interface ResultListProps {
  openResultMode: boolean;
  resultMode: string;
  controller: HeadlessResultList;
  buildGridViewResultListProduct: HeadlessResultsPerPage;
  data: any;
  isAffiliate?: boolean;
  typeFacet?: number;
  tabType?: string | null | undefined;
  isFirstLoad?: boolean;
  isNoMostPopular?:boolean;
  isShowRecommendedForModel?:any;
}

export const SearchListing: FunctionComponent<ResultListProps> = (props) => {
  //  useEffect(() => {
  //   const { logInterfaceLoad } = loadSearchAnalyticsActions(headlessEngine);
  //   const { executeSearch } = loadSearchActions(headlessEngine);
  //   headlessEngine.dispatch(executeSearch(logInterfaceLoad()));
  // }, []);
  const { controller, openResultMode, resultMode, isAffiliate } = props;
  const [state, setState] = useState(controller.state);
  // const [resultGridViewProduct, setResultGridViewProduct] = useState(9);
  const [isLoading, setLoading] = useState(true);
  // const [isLoadMore, setLoadMore] = useState(false);
  const isSafari: boolean = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  useEffect(() => controller.subscribe(() => setState(controller.state)), [
    controller,
  ]);

  // state used to check either modal is open or not
  const [isModalOpen, setModal] = useState(false);
  // effect for modal
  useEffect(() => {
    const body = document.body;
    isModalOpen ? body.classList.add("modal-open") : body.classList.remove("modal-open");
  });

  // Loading
  // Change tab and pill
  useEffect(() => {
    let loadingClass = document.getElementsByClassName("loading-container hide-icon");
    for (let i = 0; i < loadingClass.length; i++) {
      loadingClass[0].className = loadingClass[0].className.replace("loading-container hide-icon", "loading-container");
    }
  }, [props.typeFacet, props.tabType]);

  useEffect(() => {
      //@ts-ignore
      if (!window.clickLoadMore){
          window.scrollTo(0, 0);
      } else {
          //@ts-ignore
          window.clickLoadMore = false;
      }

    if (props.controller.state.results.length > 0 && !document.querySelector("loading-container hide-icon")) {
      const el = document.querySelector(".loading-container");
      if (el) {
        el.className = el?.className.replace("loading-container", el.className === "loading-container hide-icon" ? "loading-container" : "loading-container hide-icon");
        setLoading(!isLoading);
      }
    }
  }, [props.controller.state.results]);

    useEffect(() => {
        if (props.controller.state.results.length > 0 && !document.querySelector("loading-container hide-icon")) {
            const el = document.querySelector(".loading-container");
            if (el) {
                el.className = el?.className.replace("loading-container", el.className === "loading-container hide-icon" ? "loading-container" : "loading-container hide-icon");
                setLoading(!isLoading);
            }
        }
    }, [props.controller.state.results]);

  // Load more
  // useEffect(() => {
  //   setLoadMore(false);
  // }, [props.controller.state.results.length]);
  // end load more

  //Inspiration, Case studies template
  const inspirationItem = (result: any) => {
    return (
      <div className="cardDiv" key={result.uniqueId}>
        <InteractiveResult result={result}>
          <div className="cardImageDiv">
            <img src={result.raw.aem_thumbnail} width="280" height="280" />
          </div>
        </InteractiveResult>
        <div className="cardDescriptionDiv">
          <div className="onlineTrainingDiv">
            <span className="onlineTrainingSpan">{result.raw.aem_contenttype ? result.raw.aem_contenttype[0] : ""}</span>
          </div>
          <div className="cardTitleDiv">
            <InteractiveResult result={result}>
              <span className="cardTitleSpan">{result.title}</span>
            </InteractiveResult>
          </div>
          {result.raw.aem_contenttypevalue?.indexOf("canon:content/content-type/inspiration") > -1 && (
            <div className="cardDescDiv">
              <span className="cardDescSpan">{result.raw.aem_description}</span>
            </div>
          )}
          {result.raw.aem_author && (
            <div className="cardRectQuickDiv">
              <div className="cardRect3Div">
                <span className="cardRect3authorIcon"></span>
                <span className="cardRect1Span">
                  <span className="cardRect1Title">Author: </span>
                  <span className="cardRect1Desc">{result.raw.aem_author.join("; ")}</span>
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  // Training & Articles, Simulators & Calculators, Classes & Events template
  const trainingItem = (result: any) => {
    const contentType = result.raw.aem_contenttypevalue;
    const isTraningArticle = contentType?.indexOf("canon:content/content-type/training-and-articles") > -1;
    const isClassesEvent = contentType?.indexOf("canon:content/content-type/events") > -1;
    const isSimulatorCalculator = contentType?.indexOf("canon:content/content-type/simulators") > -1;
    const cardContent = isSimulatorCalculator ? result.raw.aem_contenttype?.join("; ") : result.raw.aem_type?.join("; ");
    const isSubjectInfo = (isTraningArticle && (result.raw.aem_instructor || result.raw.aem_length || result.raw.aem_price)) || (isClassesEvent && (result.raw.aem_length || result.raw.aem_price));

    return (
      <div className="cardDiv" key={result.uniqueId}>
        <InteractiveResult result={result}>
          <div className="cardImageDiv">
            <img src={result.raw.aem_thumbnail} width="280" height="280"/>
          </div>
        </InteractiveResult>
        <div className="cardDescriptionDiv">
          {result.raw.aem_skilllevel && (isTraningArticle || isClassesEvent) && (
            <div className="cardContentType">
              <span className="cardContentspan">{result.raw.aem_skilllevel.join("; ")}</span>
            </div>
          )}
          <div className="onlineTrainingDiv">
            <span className="onlineTrainingSpan">{cardContent}</span>
          </div>
          <div className="cardTitleDiv">
            <InteractiveResult result={result}>
              <span className="cardTitleSpan">{result.title}</span>
            </InteractiveResult>
          </div>
          {isSubjectInfo && (
            <div className="cardRectQuickDiv">
              {isTraningArticle && result.raw.aem_instructor && (
                <div className="cardRect1Div">
                  <span className="cardRect1Icon"></span>
                  <span className="cardRect1Span">
                    <span className="cardRect1Title">Instructor: </span>
                    <span className="cardRect1Desc">{result.raw.aem_instructor.join("; ")}</span>
                  </span>
                </div>
              )}
              {result.raw.aem_length && (
                <div className="cardRect2Div">
                  <span className="cardRect2Icon"></span>
                  <span className="cardRect2Span">
                    <span className="cardRect2Title">Length: </span>
                    <span className="cardRect2Desc">{result.raw.aem_length + " mins"}</span>
                  </span>
                </div>
              )}
              {result.raw.aem_price && (
                <div className="cardRect3Div">
                  <span className="cardRect3Icon"></span>
                  <span className="cardRect3Span">
                    <span className="cardRect3Title">Price: </span>
                    <span className="cardRect3Desc">{'$' + result.raw.aem_price}</span>
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  /**
   * Transform size number to KB or MB
   * @param bytes size data
   * @param decimals
   * @returns KB or MB number
   */
  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  // INet, Bruchures, Whitepapers, Rebate template
  const whitepaperItem = (result: any, number: any) => {
    const contentType = result.raw.aem_contenttypevalue;
    const isWhitepaper = contentType?.indexOf("canon:content/content-type/whitepaper") > -1;
    const isBrochure = contentType?.indexOf("canon:content/content-type/brochure") > -1;
    const isRebate = contentType?.indexOf("canon:content/content-type/rebate") > -1;
    const isInet = result.raw.source === "Inet Database";
    const size = isInet ? result.raw.size : result.raw.aem_damsize ? result.raw.aem_damsize : "";
    const downloadUrl = isInet ? result.raw.ineturl : result.raw.clickableuri;
    const description = result.raw.aem_contenttype ? result.raw.aem_contenttype[0] : "";

    //View PDF
    const viewPDF = (url: any, e: any, result: any, fileType: any, fileDisplayName: any) => {
      e.preventDefault();
      var link = new URL(url);
      var finalURL = link.pathname + link.search;
      var fileName = result?.raw?.clickableuri ? result.raw?.clickableuri.toString().substring(result.raw?.clickableuri.toString().lastIndexOf('/') + 1) : result.raw?.systitle;
      if (!finalURL.includes(".pdf") || !finalURL.includes("/content/dam")) {
        window.open(url, '_blank');
        return true;
      }
      else {
        var pdfUrl = `/bin/canon/getS7URLFromDam?path=${finalURL}`;
        $.ajax({
          type: "GET",
          url: pdfUrl,
          success: function (response) {
            if (response.s7URL) {
              window.open(response.s7URL, '_blank');
            }
            else {
              var damPdfUrl = `/bin/canon/downloadasset?path=${finalURL}`;
              window.open(damPdfUrl, '_blank');
            }
          },
          error: function (xhr) {
            console.log(`${url} 404: ${xhr}`);
          }
        });
        
        var downloadDamAssetData = {
          'event': 'e_DownloadDAMAssets',
          'fileName': fileName,
          'fileDisplayName': fileDisplayName || '',
          'fileType': fileType,
          'downloadedTime': eval('getDownloadedTime()'),
          'downloadedPage': $(window.location).attr('href')
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(downloadDamAssetData);
        return false;
      }
    }


    // Open Modal
    const handleShow = (idNumber: any) => {
      const element = document.getElementById("searchRebatesTnc_" + idNumber);
      element?.setAttribute("style", "display:block");
      const contentElement = element?.querySelectorAll(".modal-content")[0];
      if (contentElement?.classList.contains("popover")) {
        contentElement.classList.remove("popover");
      }
      if (contentElement?.classList.contains("d-none")) {
        contentElement.classList.remove("d-none");
      }
      setModal(true);
    };

    // Close Modal
    const handleClose = (event: any, idNumber: any) => {
      event.stopPropagation();
      const baseElement = event.target;
      // Elements with class name that wont close when clicked
      const classNames = ['modal-body', 'modal-title', 'modal-header'];
      if (classNames.some(function (className) { return baseElement.classList.contains(className); })) {
        return;
      }
      const element = document.getElementById("searchRebatesTnc_" + idNumber);
      element?.removeAttribute("style");
      setModal(false);
    };

    return (
      <div className={isInet ? "sandpCard iNetData" : "sandpCard"} key={result.uniqueId}>
        <div className="sandpCard-row">
        {!isInet ? (
            <div className="sandpCard-row-container">
              <InteractiveResult result={result}>
                <img
                    width="280"
                    height="280"
                  className="sandpCard-row-container-image"
                  src={result.raw.aem_thumbnail}
                  alt="thumbnail"
                />
              </InteractiveResult>
            </div>
          ) : isInet && result.raw?.filetype === filetype.PDF ? (
            ""
            // <div className="sandpCard-row-container">
            //   <InetPdfPreview result={result}></InetPdfPreview>
            // </div>
          ) : (
            ""
          )}
          <div className="sandpCard-row-textBox">
            <div className="sandpCard-row-textBox-text">
              <InteractiveResult result={result}>
                <div className="sandpCard-row-textBox-text-title">{result.title}</div>
              </InteractiveResult>
              {!isInet && (
                <div className="sandpCard-row-textBox-text-description">{description}</div>
              )}
              {isInet && result.raw.inetdescription && (
                <div className="sandpCard-row-textBox-text-description">{result.raw.inetdescription}</div>
              )}
              <div className="sandpCard-row-textBox-text-download">
                <div className="cta-btn-container download desktop">
                  <div className="outlined-btn-wrapper">
                    <a role="button" className="btn btn-primary btn-common outlined-button cta-active"
                      target={result.raw?.filetype !== filetype.PDF ? "_blank" : "_self"} download="" 
                      onClick={(e)=>{return viewPDF(downloadUrl, e, result, result.raw?.aem_contenttype[0], result.raw?.title)}} 
                      href={result.raw?.filetype !== filetype.PDF ? downloadUrl : "#"}>
                      <div className="desktop-download-btn-content">
                        Download
                        <div className="sandpCard-row-textBox-text-download-icon"></div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {(isWhitepaper || isBrochure || isInet) && (
              <div className="sandpCard-row-textBox-size">
                <div className="sandpCard-row-textBox-size-text">{formatBytes(size)}</div>
              </div>
            )}
            {isRebate && ( //9/25/2020 - 10/23/2020
              <div className="sandpCard-row-textBox-size">
                <div className="sandpCard-rebates-container">
                  <div className="dateAddon"></div>
                  <div className="sandpCard-row-textBox-size-text">{`${new Date(result.raw.aem_startdate).toLocaleDateString()} - ${new Date(result.raw.aem_enddate).toLocaleDateString()}`}</div>
                </div>
                <div className="sandpCard-row-textBox-size-text sandpCard-rebates-container-rebatesText"
                  data-toggle="modal" data-target={"#searchRebatesTnc_" + number} onClick={() => { handleShow(number); }}>
                  Terms &amp; Conditions
                </div>

                <div className="modal rebates-termsnConditions modal-rebates-termsnConditions" id={"searchRebatesTnc_" + number} onClick={(e) => { handleClose(e, number); }}>
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title">Terms &amp; Conditions</h4>
                        <button type="button" className="close rebates_tnc_close" data-dismiss="modal" onClick={(e) => { handleClose(e, number); }} ></button>
                      </div>
                      <div className="modal-body">{result.raw.aem_tc ? result.raw.aem_tc : ''}</div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-danger rebates_tnc_close" data-dismiss="modal" onClick={(e) => { handleClose(e, number); }}>Close</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="sandpCard-textBox-text-mobileDownload">
          <div className="cta-btn-container download desktop">
            <div className="outlined-btn-wrapper">
              <a role="button" className="btn btn-primary btn-common outlined-button cta-active" target="_blank" href={downloadUrl}>
                <div className="desktop-download-btn-content">
                  Download
                  <div className="sandpCard-row-textBox-text-download-icon"></div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const removeTags = (str: any) => {
    if ((str===null) || (str===''))
    return false;
    else
    return str?.replace( /(<([^>]+)>)/ig, '');
  }

  //OKB, General, Product support template
  const productSupportItem = (result: any, index: number) => {
    const contentType = result.raw.aem_contenttypevalue ? result.raw.aem_contenttypevalue : null;
    const supportContentType = result.raw.commonsupportcontenttype ? result.raw.commonsupportcontenttype : null;
    const isSalesForce = ["B2B QA - Salesforce Knowledge", "B2B - Salesforce Knowledge", "Salesforce Knowledge Base"].includes(result.raw.source);
    const isGeneralSupport = contentType?.indexOf("canon:content/content-type/general-support") > -1;
    const isProductSupport = contentType?.indexOf("canon:content/content-type/product-support") > -1;
    const cardContent = isSalesForce ? result.raw.sfrecordtypename : supportContentType;
    const isOosl = result.raw.retired_product && result.raw.retired_product.toLowerCase() === "yes";

    const accordion = [
      {
        value: "Advisories",
        anchor: result.raw.aem_advisories_flag ? result.raw.aem_advisories_flag : null,
      },
      {
        value: "Apps",
        anchor: result.raw.aem_apps_flag ? result.raw.aem_apps_flag : null,
      },
      {
        value: "Error Codes",
        anchor: result.raw.aem_error_codes_flag ? result.raw.aem_error_codes_flag : null,
      },
      {
        value: "FAQs",
        anchor: result.raw.aem_faqs_flag ? result.raw.aem_faqs_flag : null,
      },
      {
        value: "Fax Help",
        anchor: result.raw.aem_fax_help_flag ? result.raw.aem_fax_help_flag : null,
      },
      {
        value: "How-to Videos",
        anchor: result.raw.aem_how_to_videos_flag ? result.raw.aem_how_to_videos_flag : null,
      },
      {
        value: "Manuals",
        anchor: result.raw.aem_manuals_flag ? result.raw.aem_manuals_flag : null,
      },
      {
        value: "Operating System Help",
        anchor: result.raw.aem_operating_system_compatibility_flag ? result.raw.aem_operating_system_compatibility_flag : null,
      },
      {
        value: "Service upgrades",
        anchor: result.raw.aem_service_upgrades_flag ? result.raw.aem_service_upgrades_flag : null,
      },
      {
        value: "Technical Specifications",
        anchor: result.raw.aem_technical_specifications_flag ? result.raw.aem_technical_specifications_flag : null,
      },
      {
        value: "Warranty Information",
        anchor: result.raw.aem_warranty_info_flag ? result.raw.aem_warranty_info_flag : null,
      },
      {
        value: "Wireless Help",
        anchor: result.raw.aem_wireless_help_flag ? result.raw.aem_wireless_help_flag : null,
      },
      {
        value: "Software & Drivers",
        anchor: result.raw.aem_software_drivers_flag ? result.raw.aem_software_drivers_flag : null,
      },
      {
        value: "Supplies & Accessories",
        anchor: result.raw.aem_supplies_accessories_flag ? result.raw.aem_supplies_accessories_flag : null,
      },
      {
        value: "Software Development Kit",
        anchor: result.raw.aem_software_development_kit_flag ? result.raw.aem_software_development_kit_flag : null,
      },
    ];

    return (
      <div className="cardDiv general-support-card product-result-support" key={result.uniqueId}>
        <div className="cardDescriptionDiv htv_cardDescriptionDiv gs_cardDescriptionDiv">
          <div className="cardContentType">
            <span className="cardContentSpan">{cardContent}</span>
          </div>
          <div className="cardTitleDiv htwCardTitleDiv">
            <InteractiveResult openNewTab={isSalesForce} result={result} hasOosl={isProductSupport && isOosl}>
              <span className="cardTitleSpan">{result.title}</span>
            </InteractiveResult>
          </div>
          {isGeneralSupport && result.raw.aem_description && (
            <div className="cardDescDiv htwCardDescDiv">
              <span className="cardDescSpan">{result.raw.aem_description}</span>
            </div>
          )}
          {isSalesForce && (
            <div className="cardDescDiv htwCardDescDiv">
              <span className="cardDescSpan">{removeTags(result.raw.sfdescription__c)}</span>
            </div>
          )}
          {isProductSupport && (
            <div className="dv-quick-links">
              {accordion.map((item: any) => {
                if (item.anchor) {
                  const ooslValue : HTMLInputElement | null = document.querySelector("input[name=ooslPath]");
                  const ooslPath = ooslValue?.value + `?prodName=${encodeURIComponent(result.title)}`;
                  const href = `${result.clickUri}#${encodeURIComponent(`idReference=${item.anchor}`)}`;
                  return (
                    <div className="dv-quick-link" key={result.uniqueId + item.value + index}>
                      <a className="quick-link" href={href}>{item.value}</a>
                    </div>
                  );
                }
                else { return ""; }
              })}
            </div>
          )}
        </div>
      </div>
    );
  };

  //Community Template
    const communityItem = (result: any, index: number) => {
        const cardContent = result.raw.community_type == "Specific Posts" ? "Post": result.raw.community_type?.replace(/s$/, "");
        const numerLikeText = result.raw.limessagekudoscount > 1? `${result.raw.limessagekudoscount} likes`: `${result.raw.limessagekudoscount} like`;
        const communityDate = new Date(result.raw.limessageposttime).toLocaleString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: 'numeric'
        }).replaceAll("/", "-").replaceAll(",", "");
        const arrayReplaceBlank = ["</ol>","</OL>","</ul>","</UL>","</li>","</LI>"];
        const arrayReplaceBlankByRegex = [
            /(<[pP])([\sa-zA-Z0-9!_@#$%^&*(),.?\":{}|=-]*>)/g,
            /(<[dD]+[Ii]+[Vv]+)([\sa-zA-Z0-9!_@#$%^&*(),.?\":{}|=-]*>)/g,
            /(<blockquote)([\sa-zA-Z0-9!_@#$%^&*(),.?\":{}|=-]*>)/g,
            /(<BLOCKQUOTE)([\sa-zA-Z0-9!_@#$%^&*(),.?\":{}|=-]*>)/g,
            /(<[lL]+[Ii]+)([\sa-zA-Z0-9!_@#$%^&*(),.?\":{}|=-]*>)/g];
        const arrayReplaceToBr = ["</p>", "</P>","</div>", "</DIV>", "</blockquote>", "</BLOCKQUOTE>"];
        const arrayReplaceBRByRegex = [
            /(<[oO]+[lL]+)([\sa-zA-Z0-9!_@#$%^&*(),.?\":{}|=-]*>)/g,
            /(<[uU]+[lL]+)([\sa-zA-Z0-9!_@#$%^&*(),.?\":{}|=-]*>)/g];
        let limessagebody = result.raw.limessagebody;

        if(limessagebody && iOS()) {
            var virtualDiv = document.createElement("div");
            virtualDiv.innerHTML = limessagebody;
            var bodyOL = virtualDiv.querySelectorAll("ol");
            var bodyUL = virtualDiv.querySelectorAll("ul");
            Array.from(bodyOL).forEach((item)=> {
                var liItem = item.querySelectorAll("li");
                Array.from(liItem).forEach((item, index )=> {
                    var spanItem = document.createElement("span");
                    var brItem = document.createElement("br");
                    spanItem.classList.add("span-ol");
                    spanItem.innerHTML = "<u class='u-ol'>" + (index + 1) + ". </u>" + item.innerHTML;
                    item.innerHTML = "";
                    item.append(spanItem);
                    item.append(brItem);
                });
            });
            Array.from(bodyUL).forEach((item)=> {
                var liItem = item.querySelectorAll("li");
                Array.from(liItem).forEach((item)=> {
                    var spanItem = document.createElement("span");
                    var brItem = document.createElement("br");
                    spanItem.classList.add("span-ul");
                    spanItem.innerHTML = item.innerHTML;
                    item.innerHTML = "";
                    item.append(spanItem);
                    item.append(brItem);
                });
            });
            limessagebody = virtualDiv.innerHTML;
            arrayReplaceBlank.forEach(item => limessagebody = limessagebody.replaceAll(item, ""));
            arrayReplaceBlankByRegex.forEach(item => limessagebody = limessagebody.replace(item, ""));
            arrayReplaceBRByRegex.forEach(item => limessagebody = limessagebody.replace(item, "<br/>"));
            arrayReplaceToBr.forEach(item => limessagebody = limessagebody.replaceAll(item, "<br/>"));
        }
        return (
            <div className="cardDiv general-support-card product-result-support community-card" key={result.uniqueId}>
                <div className="cardDescriptionDiv htv_cardDescriptionDiv gs_cardDescriptionDiv">
                    <div className="cardContentType">
                        <span className="cardContentSpan">{cardContent}</span>
                    </div>
                    <div className="cardTitleDiv htwCardTitleDiv">
                        <InteractiveResult result={result} openNewTab={true}>
                            {
                                result.raw.community_solved && (
                                    <span className="cardSolveSpan">{result.raw.community_solved}</span>
                                )
                            }
                            <span className="cardTitleSpan">{result.title}</span>
                        </InteractiveResult>
                      <p className="cardAuthor">
                          by {result.raw.litopicauthor} in {result.raw.liboardtitle}
                          <span className="show-on-mobile hide">
                            {communityDate}
                              {
                                  result.raw.limessagekudoscount > 0 && (<Fragment><br/>{numerLikeText}</Fragment>)
                              }
                          </span>
                      </p>
                    </div>
                    <div className="cardDescDiv htwCardDescDiv">
                        <div className={`cardDescSpan${iOS() ?" cardDescSpan-ios": ""}`}
                              dangerouslySetInnerHTML={{
                                  __html: limessagebody,
                              }}/>
                    </div>
                </div>
              <div className="cardInfoDiv hide-on-mobile">
                  <p>{communityDate}</p>
                {
                  result.raw.limessagekudoscount > 0 && (<p>{numerLikeText}</p>)
                }
              </div>
            </div>
        );
    };

    function iOS() {
        try {
            var userAgent = navigator.userAgent.toLowerCase();
            return [
                    'iPad Simulator',
                    'iPhone Simulator',
                    'iPod Simulator',
                    'iPad',
                    'iPhone',
                    'iPod'
                ].includes(navigator.platform)|| (navigator.platform.indexOf("Mac") >= 0 && userAgent.indexOf('safari') >= 0 && userAgent.indexOf('chrome') < 0)
                // iPad on iOS 13 detection
                || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        } catch (e) {
            return false;
        }

    }
  //How to video template

  const handleFirstPlayVideo = (element: any, videoId: string) => {
        //@ts-ignore
      if (window.Canon && window.Canon.isBlockAdvertisingCookie()) {
          //@ts-ignore
          window.Canon.openPopupAllowCookies();
          return;
      }
      if (!videoId) {
          return;
      }
      let parent = element.parentElement
      let playButton = parent.querySelector(".play-btn")!;
      let thumbnailElm = parent.querySelector(".thumbnail-video")!;
      let iframeYoutube = parent.querySelector("#player")!;
      playButton.setAttribute("style", "display: none");
      if (thumbnailElm) {
          thumbnailElm.setAttribute("style", "display: none");
      }
      iframeYoutube.setAttribute("style", "display: block");
      iframeYoutube.setAttribute("src", "https://www.youtube.com/embed/" + videoId! + "?autoplay=1");
  }
  const htvItem = (result: any) => {
    let videoUrl = result.raw.aem_videourl ? result.raw.aem_videourl : null;
    let videoId = "";
    let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    let thumbnail = result.raw.aem_thumbnail ? result.raw.aem_thumbnail : null;
    if (videoUrl) {
      let match = videoUrl.match(regExp);
      if (match && match[2].length === 11) {
        videoId = match[2];
      } else {
        videoId = 'no video found';
      }
    }
    if (thumbnail) {
        thumbnail = "https://" + thumbnail.substring(thumbnail.indexOf("img.youtube.com"));
    }
    return (
      <div className="cardDiv htwCardDiv" key={result.uniqueId}>
        <div id={videoId} className="cardImageDiv htvcardImageDiv">
            {videoId && (<div className="thumbnail-wrap" onClick={(e:any) => {
                handleFirstPlayVideo(e.currentTarget,videoId)
            }}>
                <div className="play-btn"></div>
                {thumbnail && (<img className="thumbnail-video" src={thumbnail} alt=""/>)}
            </div>)}
            {<iframe id="player" width="286" height="160" frameBorder="0" allow='autoplay' allowFullScreen style={{display: "none"}}></iframe>}
        </div>
        <div className="cardDescriptionDiv htv_cardDescriptionDiv">
          <div className="onlineTrainingDiv htwOnlineTrainingDiv">
            <span className="onlineTrainingSpan">{result.raw.aem_contenttype ? result.raw.aem_contenttype[0] : ""}</span>
          </div>
          <div className="cardTitleDiv htwCardTitleDiv">
            <InteractiveResult result={result} videoId={videoId} openNewTab={true && videoId !== ""}>
              <span className="cardTitleSpan">{result.title}</span>
            </InteractiveResult>
          </div>
          <div className="cardDescDiv htwCardDescDiv">
            <span className="cardDescSpan">{result.raw.aem_description}</span>
          </div>
            <WasThisHelpful
                videoId={videoId}
                videoTitle={result.title}
            />
        </div>
      </div>
    );
  };

  // Industry template
  const industryItem = (result: any) => {
    return (
      <div className="industryCardDiv" key={result.uniqueId}>
        <InteractiveResult result={result}>
          <div className="cardImageDiv">
            <img src={result.raw.aem_thumbnail} width="280" height="280"/>
          </div>
        </InteractiveResult>
        <div className="cardDescriptionDiv">
          <div className="cardTitleDiv">
            <InteractiveResult result={result}>
              <span className="cardTitleSpan">{result.title}</span>
            </InteractiveResult>
          </div>
          <div className="cardDescDiv">
              <span className="cardDescSpan">{result.raw.aem_description}</span>
          </div>
        </div>
      </div>
    );
  };

  const downloadItem = (result: any, index: number) => {
      return <InetDownload  result={result} isShowRecommendedForModel={props.isShowRecommendedForModel}></InetDownload>
  }

  if (!state.results.length) {
    if (isAffiliate && !props.isFirstLoad) {
      return <AffiliateNoResultFilter />;
    } else {
      return <NoResultsByFilters />;
    }
  }

  const listResultMode = (resultMode: string) => {
    if (isAffiliate) {
      return (
        <div id="products-mode" className={"products product-" + resultMode}>
          <ol className="product-result-list">
            {
              state.results.map((result, index) => (<Product listMode={resultMode} isSafari={isSafari} isAffiliate={true} dataMagento={props.data ? props.data : []} result={result} index={index} key={result.uniqueId}></Product>))
            }
          </ol>
        </div>
      );
    }
    else
      return (
        <div id="products-mode" className={"products product-" + resultMode}>
            {props.isNoMostPopular && (<h3 className={"h3 title"}>MORE RESULTS</h3>)}
          <ol className="product-result-list">
            {
              state.results.filter((result: any) => (result.raw.commoncontenttype !== undefined && result.raw.commoncontenttype[0] === "Products")).map((result, index) =>
                (<Product listMode={resultMode} isSafari={isSafari} dataMagento={props.data ? props.data : []} result={result} index={index} key={result.uniqueId}></Product>))
            }
          </ol>
        </div>
      );
  };

  const activePill = document.querySelector(".pill-item.selected")?.getAttribute("id");
  const fetchMore = () => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      'event': 'e_scrollLoadMoreClick'
    });
    // @ts-ignore
  	window.clickLoadMore = true;

    controller.fetchMoreResults();
  };
  return (
    <div className="result-list">
      {!openResultMode &&
        state.results.map((result: any, index: number) => {
          if (activePill && activePill !== "Products") {
            const contentType = result.raw.aem_contenttypevalue;
            const isInetSource = result.raw.source === "Inet Database";
            const isDownloadContent = ["Inet Dev - Software and Drivers", "Inet - Software and Drivers"].includes(result.raw.source);            
            const isWhitepaper = contentType?.indexOf("canon:content/content-type/whitepaper") > -1;
            const isInspiration = contentType?.indexOf("canon:content/content-type/inspiration") > -1;
            const isCaseStudies = contentType?.indexOf("canon:content/content-type/case-studies") > -1;
            const isTrainingArticle = contentType?.indexOf("canon:content/content-type/training-and-articles") > -1;
            const isSimulatorCalculator = contentType?.indexOf("canon:content/content-type/simulators") > -1;
            const isHowToVideos = contentType?.indexOf("canon:content/content-type/videos/how-to-videos") > -1;

              switch (activePill) {
              case "Support":
                return isWhitepaper || isInetSource ? whitepaperItem(result, index) :
                  isHowToVideos ? htvItem(result) :
                    isDownloadContent ? downloadItem(result, index) :
                      productSupportItem(result, index);
              case "Learning":
                return isInspiration || isCaseStudies
                  ? inspirationItem(result)
                  : trainingItem(result);
              case "Inspiration":
                return inspirationItem(result);
              case "Resources":
                return isTrainingArticle || isSimulatorCalculator
                  ? trainingItem(result)
                  : whitepaperItem(result, index);
              case "Industries":
                return industryItem(result);
                case "Community":
                  return communityItem(result, index);
              default:
                return trainingItem(result);
            }
          }
        })}
      {openResultMode&& (resultMode === viewMode.GRID
          ? listResultMode(viewMode.GRID)
          : listResultMode(viewMode.LIST))}
      {controller.state.moreResultsAvailable && (
        <div className="loadMoreWrapper">
          <div className="loadMoreButton">
            <span className="loadMore" onClick={fetchMore}>Load More</span>
            {/* {
              isLoadMore ? (
                <div className="loadmore-container">
                  <div className="loadmore-spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              ) : ""
            } */}
          </div>
        </div>
      )}
    </div>
  );
};
